import { render, staticRenderFns } from "./creatSeckill.vue?vue&type=template&id=21d3798c&scoped=true"
import script from "./creatSeckill.vue?vue&type=script&lang=js"
export * from "./creatSeckill.vue?vue&type=script&lang=js"
import style0 from "./creatSeckill.vue?vue&type=style&index=0&id=21d3798c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d3798c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d3798c')) {
      api.createRecord('21d3798c', component.options)
    } else {
      api.reload('21d3798c', component.options)
    }
    module.hot.accept("./creatSeckill.vue?vue&type=template&id=21d3798c&scoped=true", function () {
      api.rerender('21d3798c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/seckill/seckillActivity/creatSeckill.vue"
export default component.exports